import { render, staticRenderFns } from "./hotMeta.vue?vue&type=template&id=671bfd14&"
import script from "./hotMeta.ts?vue&type=script&lang=ts&"
export * from "./hotMeta.ts?vue&type=script&lang=ts&"
import style0 from "./hotMeta.vue?vue&type=style&index=0&id=671bfd14&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports